<div
  #panel
  class="context-menu-panel"
  [class.styled]="mode() === 'styled'"
  [class.transparent]="mode() === 'transparent'"
  [class.visible]="isOpen()"
  [style.top]="panelStyle['top']"
  [style.bottom]="panelStyle['bottom']"
  [style.left]="panelStyle['left']"
  [style.right]="panelStyle['right']"
  [style.width]="panelStyle['width']">
  @if (hasBeenOpened()) {
    <ng-content />
  }
</div>
